import React, { useState } from 'react';
import Header from '../../component/layout/Header';
import Footer from '../../component/layout/Footer';
import Page from '../../component/utility/Page';

import Operation from '../../component/utility/setting/Operation';
import Compliance from '../../component/utility/setting/Compliance';
import Planning from '../../component/utility/setting/Planning';

import { Row, Col, Card, CardBody } from 'reactstrap';
import { MdSettings } from "react-icons/md";
import { FaBuilding, FaClipboardCheck, FaProjectDiagram } from "react-icons/fa";

import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';

// Enhanced TabPanel with animations
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      style={{
        opacity: value === index ? 1 : 0,
        transform: value === index ? 'translateY(0)' : 'translateY(10px)',
        transition: 'all 0.3s ease-in-out'
      }}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const Organisation = () => {
    const [value, setValue] = useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const tabsData = [
        { 
            label: "Operation", 
            icon: MdSettings,
            description: "Manage daily operations and workflows"
        },
        { 
            label: "Compliance", 
            icon: FaClipboardCheck,
            description: "Monitor regulatory compliance and standards"
        },
        { 
            label: "Planning", 
            icon: FaProjectDiagram,
            description: "Strategic planning and resource allocation"
        }
    ];

    return (
        <>
            <Header />
            
            <div className="page-container">
                <Page title='Organisation' breadcrumbs='Home / Organisation'>
                    
                    {/* Dashboard Header */}
                    <div className="dashboard-header p-3 mb-3 mt-3">
                        <Row className="align-items-center">
                            <Col>
                                <h4 className="mb-1 fw-bold">Organisation Management</h4>
                                <p className="mb-0 opacity-90">Configure and manage your organisation settings, compliance, and planning</p>
                            </Col>
                            <Col xs="auto">
                                <FaBuilding size={48} className="opacity-75" />
                            </Col>
                        </Row>
                    </div>  

                    {/* Enhanced Tabs Section */}
                    <Card className="shadow-sm border-0" style={{ borderRadius: '10px' }}>
                        <CardBody className="p-0">
                            <Box sx={{ width: '100%' }} className="enhanced-tabs">
                                <Box sx={{ borderBottom: 'none', p: 2 }}>
                                    <Tabs 
                                        value={value} 
                                        onChange={handleChange} 
                                        aria-label="organisation tabs"
                                        sx={{
                                            '& .MuiTabs-indicator': {
                                                display: 'none'
                                            },
                                            '& .MuiTab-root': {
                                                textTransform: 'none',
                                                minWidth: 120,
                                                fontWeight: 500,
                                                fontSize: '0.95rem',
                                                padding: '12px 24px',
                                                margin: '0 8px',
                                                borderRadius: '8px',
                                                transition: 'all 0.3s ease',
                                                '&:hover': {
                                                    backgroundColor: 'rgba(7, 101, 56, 0.08)',
                                                    color: "primary"
                                                },
                                                '&.Mui-selected': {
                                                    backgroundColor: "primary",
                                                    color: 'white',
                                                    '&:hover': {
                                                        backgroundColor: "primary"
                                                    }
                                                }
                                            }
                                        }}
                                    >
                                        {tabsData.map((tab, index) => (
                                            <Tab 
                                                key={index}
                                                label={
                                                    <div className="d-flex align-items-center gap-2">
                                                        <tab.icon size={18} />
                                                        {tab.label}
                                                    </div>
                                                } 
                                                {...a11yProps(index)} 
                                            />
                                        ))}
                                    </Tabs>
                                </Box>
                                
                                {/* Tab Descriptions */}
                                <div className="px-4 pb-3">
                                    <p className="mb-0 text-muted small">
                                        {tabsData[value]?.description}
                                    </p>
                                </div>
                                
                                <div style={{ minHeight: '400px' }}>
                                    <TabPanel value={value} index={0}>
                                        <Operation />
                                    </TabPanel>
                                    <TabPanel value={value} index={1}>
                                        <Compliance /> 
                                    </TabPanel>
                                    <TabPanel value={value} index={2}>
                                        <Planning />
                                    </TabPanel>
                                </div>
                            </Box>
                        </CardBody>
                    </Card>
                </Page>
            </div>
            
            <Footer />

            <style jsx>{`

                .dashboard-header {
                    color: white;
                    border-radius: 10px;
                    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
                }

                .stat-card {
                    transition: transform 0.2s ease, box-shadow 0.2s ease;
                    border-radius: 10px !important;
                }

                .stat-card:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15) !important;
                }

                .stat-icon {
                    width: 60px;
                    height: 60px;
                    border-radius: 12px;
                    font-size: 1.5rem;
                }

                .stat-title {
                    font-size: 0.85rem;
                    letter-spacing: 0.5px;
                }

                .stat-value {
                    font-size: 2rem;
                    line-height: 1.2;
                }

                .enhanced-tabs .MuiTabs-flexContainer {
                    gap: 8px;
                }

                .loading-skeleton {
                    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
                    background-size: 200% 100%;
                    animation: loading 1.5s infinite;
                    border-radius: 4px;
                }

                @keyframes loading {
                    0% {
                        background-position: 200% 0;
                    }
                    100% {
                        background-position: -200% 0;
                    }
                }

                @media (max-width: 768px) {
                    .dashboard-header h4 {
                        font-size: 1.25rem;
                    }
                    
                    .stat-value {
                        font-size: 1.5rem;
                    }
                    
                    .stat-icon {
                        width: 50px;
                        height: 50px;
                    }
                }
            `}</style>
        </>
    )
}

export default Organisation;